export default __webpack_public_path__ + "ad0ab62d5d639c2e1f6e8064d5eb0915.woff";